import styled from 'styled-components';
import { theme } from 'styled-tools';
import { rem } from 'polished';

import { getIcon } from './ui/icons/SocialIcons';

const Socials = styled.ul`
  list-style: none;
  margin: 0;
  margin-top: 1rem;
  padding: 0;
  font-size: 24px;
`;

const ListItem = styled.li`
  margin: 0;
  padding: 0;
  padding-right: ${rem(24)};
  display: inline-block;

  a,
  svg {
    color: ${theme('colors.mediumGray')};
    &:hover {
      color: ${theme('colors.orange')};
      opacity: 1;
    }
  }
`;

const SocialLinks = ({ socials, ...props }) => {
  return (
    <Socials {...props}>
      {(socials || []).map((social) => {
        const SocialLinkIcon = getIcon(social.platform.socialNetworkName);

        if (!SocialLinkIcon) {
          return null;
        }

        return (
          <ListItem key={social.url}>
            <SocialLinkIcon url={social.url} />
          </ListItem>
        );
      })}
    </Socials>
  );
};

export default SocialLinks;
